module.exports = __webpack_public_path__ + "img/innovations_small@2x.cce7ffc0.jpg";